import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProvidersCollection } from '../../interfaces/IProvider';

@Injectable({
  providedIn: 'root',
})
export class DeliveryProviderService {
  constructor(private http: HttpClient) {}

  getProviders(): Observable<ProvidersCollection> {
    return this.http.get<ProvidersCollection>('/assets/delivery-provider/delivery-provider.json');
  }
}
